import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import servicioAsignacionValoresObjetos from '../servicio/ServicioObjetos';
import servicioHttp from '../servicio/ServicioHttp';
import { Growl } from 'primereact/growl';


export class Parametro extends Component {

    constructor() {
        super();
        this.state = {
            parametro: {},
            mostraModalParametro: false,
            mostrarModalConfirmacion: false,
            mostrarParametroActualizar: false,
            errores: {},
            paginacion: { registrosPorPagina: 20 },
        }
    }

    componentDidMount() {
        this.obtenerParametro();

    }

    cambiaPagina(event) {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first, paginacion });
        this.obtenerPagina();
    }

    obtenerPagina() {
        servicioHttp.consumirPostHttp("parametro/consultar.json").then((response) => {
            this.setState({ paginacion: response.data.objeto });
        })
            .catch((error) => {
                return this.growl.show({
                    severity: "error", summary: "", detail: "Se generó un error no esperado, por favor inténtelo de nuevo",
                });
            });
    }

    obtenerParametro = () => {
        servicioHttp.consumirPostHttp("parametro/consultar.json").then(response => {
            this.setState({ paginacion: response.data.objeto })
        })
            .catch(e => console.error(e))
    }

    mostrarModal() {
        this.setState({ mostraModalParametro: true });
    }

    asignarValores = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, false);
    }

    //método guardar (almacena información a la BD a através de  archivo .json-controlador)
    guardarParametro() {
        let { parametro } = this.state;
        const validacion = this.validarFormulario(parametro);
        this.setState({ errores: validacion });
        if (!Object.keys(validacion).length) {
            servicioHttp.consumirPostHttp("parametro/guardar.json", parametro).then(response => {
                this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                this.resetEstados();
                this.obtenerPagina();
            }).catch(error => {
                return this.growl.show({ severity: 'error', summary: '', detail: 'Se generó un error inesperado!!!, por favor inténtelo de nuevo' });
            })
        }
    }

    actualizarParametro() {
        let { parametro } = this.state;
        const validacion = this.validarFormulario(parametro);
        this.setState({ errores: validacion });
        if (!Object.keys(validacion).length) {
            servicioHttp.consumirPostHttp("parametro/actualizar.json", parametro).then(response => {
                this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                this.restarurarValores();
                this.obtenerPagina();
            }).catch(error => {
                return this.growl.show({ severity: 'error', summary: '', detail: 'Se generó un error inesperado!!!, por favor inténtelo de nuevo' });
            })
        }
    }

    resetEstados() {
        this.setState({
            mostraModalParametro: false,
            mostrarModalConfirmacion: false,
            parametro: {},
            errores: {},
        });
    }

    restarurarValores() {
        this.setState({ mostrarModalActualizar: false, parametro: {} });
    }

    validarFormulario = (parametro) => {
        const errores = {};
        if (!parametro.nombre) {
            errores.nombre = "El campo es requerido";
        }
        if (!parametro.valor) {
            errores.valor = "El campo es requerido";
        }
        if (!parametro.descripcion) {
            errores.descripcion = "El campo es requerido";
        }
        return errores;
    }

    actualizar(objeto) {
        var empresaEditar = JSON.parse(JSON.stringify(objeto));
        this.setState({ mostrarModalActualizar: true, parametro: empresaEditar });
    }

    eliminar = () => {
        let { parametro } = this.state;
        servicioHttp.consumirPostHttp("parametro/eliminar.json", parametro).then(response => {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            this.resetEstados();
            this.obtenerPagina();
        }).catch(error => {
            return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        })

    }

    mostrarModalEliminar = (objeto) => {
        this.setState({ mostrarModalConfirmacion: true, parametro: objeto });
    }

    plantillaOpciones(rowData, column) {
        return <div className="p-grid">

            <div className="p-col-12 p-md-2">
                <Button type="button" icon="pi-md-edit" onClick={(e) => this.actualizar(column.rowData)} className="p-button-warning" name="editar" tooltip="Editar">
                </Button>
                <Button type="button" icon="pi-md-delete" onClick={(e) => this.mostrarModalEliminar(column.rowData)} className="p-button-danger" name="eliminar" tooltip="Eliminar" >
                </Button>
            </div>
        </div>;
    }

    render() {
        let { parametro, errores, paginacion } = this.state;
        const pieDialogo = <div className="ui-dialog-buttonpane p-clearfix">
            <Button label="Guardar" icon="pi-md-save" onClick={this.guardarParametro.bind(this)} />
            <Button label="Cancelar" icon="pi-md-close" onClick={this.resetEstados.bind(this)} className="p-button-danger " />
        </div>;
        const pieDialogUpdate = <div className="ui-dialog-buttonpane p-clearfix">
            <Button label="Guardar" icon="pi-md-save" onClick={this.actualizarParametro.bind(this)} />
            <Button label="Cancelar" icon="pi-md-close" onClick={this.restarurarValores.bind(this)} className="p-button-danger " />
        </div>;
        const dialogFooterConfirmacionEliminar = (
            <div>
                <Button icon="pi-md-check" onClick={this.eliminar} label="Si estoy seguro" />
                <Button icon="pi-md-close" onClick={() => this.setState({ parametro: {}, mostrarModalConfirmacion: false, errores: {} })} label="No estoy seguro" className="p-button-danger flat-btn" />
            </div>
        );
        return (
            <div className="p-grid">
                <Growl ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h1>Parametro</h1>
                        <div className="p-fluid p-grid">
                            <div className="p-col-12 p-md-4">
                                <Button className="p-button-Primary p-button-raised" label="Agregar" icon="pi-md-plus" tooltip={"Agregar nuevo"} onClick={this.mostrarModal.bind(this)} />
                            </div>
                        </div>
                    </div>
                </div>
                <Dialog visible={this.state.mostraModalParametro} style={{ width: '60%' }} header="Datos del Parametro" modal={true} footer={pieDialogo} onHide={this.resetEstados.bind(this)}>
                    <h4>Los campos con (*) son obligatorios, por favor captura los datos del Parametro</h4>
                    <div className="p-grid">

                        <div className="p-col-12 p-md-6">
                            <label ></label>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <label ></label>
                        </div>

                        <div className="p-col-12 p-md-4">
                            <span className="md-inputfield">
                                <InputText id="nombre" name="parametro.nombre" value={parametro.nombre || ""} className={errores.nombre ? "p-error" : ""} onChange={this.asignarValores.bind(this)} />
                                <label>*Nombre</label>
                                {errores.nombre ? <div><br /> <Message severity="error" text={errores.nombre} /> </div> : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <span className="md-inputfield">
                                <InputText id="valor" name="parametro.valor" className={errores.valor ? 'p-error' : ''} value={parametro.valor || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                <label>*Valor</label>
                                {errores.valor ? <div><br /> <Message severity="error" text={errores.valor} /> </div> : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <span className="md-inputfield">
                                <InputText id="descripcion" name="parametro.descripcion" className={errores.descripcion ? 'p-error' : ''} value={parametro.descripcion || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                <label>*Descripción</label>
                                {errores.descripcion ? <div><br /> <Message severity="error" text={errores.descripcion} /> </div> : null}
                            </span>
                        </div>
                    </div>
                </Dialog>
                <Dialog visible={this.state.mostrarModalActualizar} style={{ width: '60%' }} header="Actualizar Datos del Parametro" modal={true} footer={pieDialogUpdate} onHide={this.restarurarValores.bind(this)}>
                    <h4>Los campos con (*) son obligatorios, por favor captura los datos del Parametro</h4>
                    <div className="p-grid">

                        <div className="p-col-12 p-md-6">
                            <label ></label>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <label ></label>
                        </div>

                        <div className="p-col-12 p-md-4">
                            <span className="md-inputfield">
                                <InputText id="nombre" name="parametro.nombre" value={parametro.nombre || ""} className={errores.nombre ? "p-error" : ""} onChange={this.asignarValores.bind(this)} />
                                <label>*Nombre</label>
                                {errores.nombre ? <div><br /> <Message severity="error" text={errores.nombre} /> </div> : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <span className="md-inputfield">
                                <InputText id="valor" name="parametro.valor" className={errores.valor ? 'p-error' : ''} value={parametro.valor || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                <label>*Valor</label>
                                {errores.valor ? <div><br /> <Message severity="error" text={errores.valor} /> </div> : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <span className="md-inputfield">
                                <InputText id="descripcion" name="parametro.descripcion" className={errores.descripcion ? 'p-error' : ''} value={parametro.descripcion || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                <label>*Descripción</label>
                                {errores.descripcion ? <div><br /> <Message severity="error" text={errores.descripcion} /> </div> : null}
                            </span>
                        </div>
                    </div>
                </Dialog>
                <Dialog header="Confirmación" visible={this.state.mostrarModalConfirmacion} modal={true} style={{ width: '30vw' }} footer={dialogFooterConfirmacionEliminar} onHide={() => this.setState({ cliente: {}, mostrarModalConfirmacion: false, errores: {} })}>
                    <h2>¿Estás seguro de eliminar esta Parametro?</h2>
                </Dialog>
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <DataTable value={paginacion.datos} editable={true} selectionMode="single" responsive={true} header="Parametros" paginator={true} rows={20}>
                            <Column field="nombre" header="Nombre" autoLayout={true} />
                            {/*<Column field="valor" header="Valor" autoLayout={true} />*/}
                            <Column field="descripcion" header="Descripción" autoLayout={true} />
                            <Column header="Opciones" body={this.plantillaOpciones.bind(this)} autoLayout={true} />
                        </DataTable>
                    </div>
                </div>


            </div>

        );
    }
}
